import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './index';
import { handleOpenAgreementModal } from '../../features/global/globalSlice';
import { Agreement } from 'utils/types';

export const useClickWrapAgreementsChecker = () => {
    const dispatch = useAppDispatch();
    const isHantzTenant = useAppSelector((state) => state?.auth?.user?.isHantzTenant);
    const userAgreement = useAppSelector((state) => {
        if (isHantzTenant) {
            return state?.global?.orgInfo?.hantz;
        }
        return state?.global?.orgInfo?.userAgreement;
    }); // getorganizationconfig
    const eulaAgreement = useAppSelector((state) => state?.global?.orgInfo?.eula); // getorganizationconfig
    const termsOfUseChecked = useAppSelector((state) => state?.global?.globalConfig?.termsOfUse); // admin terms of use
    const eulaChecked = useAppSelector((state) => state?.global?.globalConfig?.eula); // admin eula
    const clickWrapAgreements = useAppSelector((state) => state?.auth?.user?.clickWrapAgreements); // loginuserinfo

    const [openUserAgreementModal, setOpenUserAgreementModal] = useState(false);
    const [openEulaAgreementModal, setOpenEulaAgreementModal] = useState(false);

    useEffect(() => {
        if (eulaChecked || termsOfUseChecked) {
            if (!clickWrapAgreements) return;
            if (!userAgreement || !eulaAgreement) return;

            const checkAgreementStatus = (agreementName: string, agreementVersion: string, isChecked: boolean) => {
                if (!isChecked) return false;
                const foundAgreement = clickWrapAgreements?.agreements?.find(
                    (el: Agreement) => el.agreementName === agreementName
                );
                const isLatest = foundAgreement?.acceptedAgreementVersion === agreementVersion;
                const isAccepted = foundAgreement?.agreementAccepted;
                return !isAccepted || !isLatest;
            };

            const userAgreementModal = userAgreement
                ? checkAgreementStatus('UserAgreement', userAgreement.version, termsOfUseChecked)
                : false;
            const eulaAgreementModal = eulaAgreement
                ? checkAgreementStatus('EulaAgreement', eulaAgreement.version, eulaChecked)
                : false;

            setOpenUserAgreementModal(userAgreementModal);
            setOpenEulaAgreementModal(eulaAgreementModal);

            if (userAgreementModal || eulaAgreementModal) {
                dispatch(handleOpenAgreementModal(true));
            }
        }
    }, [userAgreement, eulaAgreement, clickWrapAgreements, dispatch]);

    return { openUserAgreementModal, openEulaAgreementModal };
};
